/* DENY — Home 2026 : révélation au scroll (léger, sans dépendance). */
(function () {
  if (window.__dnyHome) return;
  window.__dnyHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(el) { el.classList.add('is-in'); }
  function observe(roots) {
    if (reduce || !('IntersectionObserver' in window)) { roots.forEach(show); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    roots.forEach(function (r) { io.observe(r); });
  }
  function init() { observe(Array.prototype.slice.call(document.querySelectorAll('.dny[data-dny-reveal]:not(.is-in)'))); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  /* Éditeur de thème : une section re-rendue redevient visible immédiatement. */
  document.addEventListener('shopify:section:load', function (ev) {
    var roots = ev.target.querySelectorAll('.dny[data-dny-reveal]');
    Array.prototype.forEach.call(roots, show);
  });
})();
